import { IconType } from "@/types";
import {
  BookOpen,
  Bot,
  Frame,
  LifeBuoy,
  Map,
  PieChart,
  Send,
  Settings2,
  SquareTerminal,
} from "lucide-react";

export interface NavigationItem {
  path: string;
  labelKey: string;
  icon?: IconType;
  items?: NavigationItem[];
}

export const ROUTES = {
  HOME: '/home',
  PROFILE: '/home/profile',
  PROPERTIES: '/home/properties',
  PROPERTIES_NEW: '/home/properties/new',
  PROPERTIES_COMPLEX: '/home/properties/complex',
  PROPERTIES_COMMERCIAL: '/home/properties/commercial',
  PROPERTIES_HOUSES: '/home/properties/houses',
  DOCUMENTS: '/home/documents',
  DOCUMENTS_NEW: '/home/documents/new',
  DOCUMENTS_ARCHIVE: '/home/documents/archive',
  PAYMENTS: '/home/payments',
  REQUESTS: '/home/requests',
  CHAT: '/home/chat',
  NOTIFICATIONS: '/home/notifications',
  SETTINGS: '/home/settings',
  SETTINGS_PROFILE: '/home/settings/profile',
  SETTINGS_SECURITY: '/home/settings/security',
  ADMIN: '/home/admin',
  SUPPORT: '/home/support',
  FEEDBACK: '/home/feedback',
} as const;

export const navigation: {
  main: NavigationItem[];
  secondary: NavigationItem[];
  projects: NavigationItem[];
} = {
  main: [
    {
      path: ROUTES.HOME,
      labelKey: 'navigation.home',
      icon: SquareTerminal,
    },
    {
      path: ROUTES.PROPERTIES,
      labelKey: 'navigation.properties',
      icon: Bot,
      items: [
        {
          path: ROUTES.PROPERTIES,
          labelKey: 'navigation.properties.all',
        },
        {
          path: ROUTES.PROPERTIES_NEW,
          labelKey: 'navigation.properties.new',
        },
      ],
    },
    {
      path: ROUTES.DOCUMENTS,
      labelKey: 'navigation.documents',
      icon: BookOpen,
      items: [
        {
          path: ROUTES.DOCUMENTS,
          labelKey: 'navigation.documents.all',
        },
        {
          path: ROUTES.DOCUMENTS_NEW,
          labelKey: 'navigation.documents.new',
        },
        {
          path: ROUTES.DOCUMENTS_ARCHIVE,
          labelKey: 'navigation.documents.archive',
        },
      ],
    },
    {
      path: ROUTES.SETTINGS,
      labelKey: 'navigation.settings',
      icon: Settings2,
      items: [
        {
          path: ROUTES.SETTINGS,
          labelKey: 'navigation.settings.general',
        },
        {
          path: ROUTES.SETTINGS_PROFILE,
          labelKey: 'navigation.settings.profile',
        },
        {
          path: ROUTES.SETTINGS_SECURITY,
          labelKey: 'navigation.settings.security',
        },
      ],
    },
  ],
  secondary: [
    {
      path: ROUTES.SUPPORT,
      labelKey: 'navigation.support',
      icon: LifeBuoy,
    },
    {
      path: ROUTES.FEEDBACK,
      labelKey: 'navigation.feedback',
      icon: Send,
    },
  ],
  projects: [
    {
      path: ROUTES.PROPERTIES_COMPLEX,
      labelKey: 'navigation.projects.complex',
      icon: Frame,
    },
    {
      path: ROUTES.PROPERTIES_COMMERCIAL,
      labelKey: 'navigation.projects.commercial',
      icon: PieChart,
    },
    {
      path: ROUTES.PROPERTIES_HOUSES,
      labelKey: 'navigation.projects.houses',
      icon: Map,
    },
  ],
}; 